import axiosSmartSurvey from "../../../api/axios"

export default function useSurveyImageData() {
    async function handleSubmitSearch(e, alphabet) {
        e.preventDefault()
        try {
            const results = await axiosSmartSurvey({
                method: 'POST',
                url: '/surveybuildingdata',
                data: {
                    alphabet: alphabet
                }
            })
            console.log(results)
        } catch (err) {
            console.error(err);
        }
    }
    return { handleSubmitSearch }
}
